import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { axiosInstance as axios } from '../../context/AuthContext';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';

const EMPTY = { usefulness: 0, trust: 0, want_follow_up: null, liked: '', improve: '' };

function Scale({ value, onChange, testId }) {
  return (
    <div className="flex gap-2">
      {[1, 2, 3, 4, 5].map(n => (
        <button type="button" key={n} onClick={() => onChange(n)} data-testid={`${testId}-${n}`}
                className={`w-10 h-10 rounded-full border text-sm font-semibold ${value === n ? 'bg-emerald-600 text-white border-emerald-600' : 'bg-white text-gray-700 border-gray-300'}`}>{n}</button>
      ))}
    </div>
  );
}

export function FamilyPilotSurveyDialog({ presentation, onClose, onSaved }) {
  const [f, setF] = useState(EMPTY);
  useEffect(() => { if (presentation) setF(EMPTY); }, [presentation]);
  const ready = f.usefulness && f.trust && f.want_follow_up !== null;

  const submit = async () => {
    try {
      await axios.post(`/api/pilot/family/presentations/${presentation.presentation_id}/survey`,
        { ...f, liked: f.liked || null, improve: f.improve || null });
      toast.success('Thank you for your feedback!');
      onSaved();
      onClose();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Could not send feedback');
    }
  };

  return (
    <Dialog open={!!presentation} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="family-pilot-survey-dialog">
        <DialogHeader>
          <DialogTitle>How was "{presentation?.title}"?</DialogTitle>
          <DialogDescription>Takes one minute. Your answers help us choose future sessions.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div><p className="text-sm font-medium mb-2">How useful was it for your family?</p><Scale value={f.usefulness} onChange={v => setF({ ...f, usefulness: v })} testId="fsurvey-useful" /></div>
          <div><p className="text-sm font-medium mb-2">How much do you trust the information you received?</p><Scale value={f.trust} onChange={v => setF({ ...f, trust: v })} testId="fsurvey-trust" /></div>
          <div>
            <p className="text-sm font-medium mb-2">Would you like a follow-up conversation with {presentation?.presenter_name}?</p>
            <div className="flex gap-2">
              {[[true, 'Yes, please'], [false, 'Not now']].map(([v, l]) => (
                <button type="button" key={l} onClick={() => setF({ ...f, want_follow_up: v })} data-testid={`fsurvey-followup-${v ? 'yes' : 'no'}`}
                        className={`px-4 py-2 rounded-full border text-sm ${f.want_follow_up === v ? 'bg-emerald-600 text-white border-emerald-600' : 'bg-white text-gray-700 border-gray-300'}`}>{l}</button>
              ))}
            </div>
          </div>
          <textarea rows={2} placeholder="What did you like?" value={f.liked} onChange={e => setF({ ...f, liked: e.target.value })} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm" data-testid="fsurvey-liked" />
          <textarea rows={2} placeholder="What could be better?" value={f.improve} onChange={e => setF({ ...f, improve: e.target.value })} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm" data-testid="fsurvey-improve" />
          <button onClick={submit} disabled={!ready} className="w-full bg-emerald-600 text-white rounded-lg py-2.5 font-semibold disabled:opacity-50" data-testid="fsurvey-submit-btn">Send feedback</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
